import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import Modal from 'react-modal'
import { Buffer } from "buffer";
import process from "process";

window.Buffer = Buffer;
window.process = process;

Modal.setAppElement('#root')

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
